import React from 'react';

const RegisterIllustration: React.FC = () => {
  return (
    <svg
      viewBox="0 0 600 600"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full h-auto"
    >
      {/* Background circles */}
      <circle cx="450" cy="100" r="100" fill="#DBEAFE" opacity="0.6" />
      <circle cx="100" cy="500" r="80" fill="#FEF3C7" opacity="0.5" />
      <circle cx="500" cy="450" r="60" fill="#D1FAE5" opacity="0.4" />

      {/* Main character - Person with welcome gesture */}
      <g transform="translate(300, 280)">
        {/* Shadow */}
        <ellipse cx="0" cy="110" rx="50" ry="15" fill="#D1D5DB" opacity="0.3" />

        {/* Body */}
        <path d="M -30 30 Q -32 60 -38 100 L -18 100 L -10 50 L 0 50 L 10 50 L 18 100 L 38 100 Q 32 60 30 30 Z" fill="#10B981" />

        {/* Arms - Welcoming gesture */}
        <path d="M -30 40 Q -55 30 -65 20 L -60 10 Q -45 25 -25 35 Z" fill="#34D399" />
        <path d="M 30 40 Q 55 30 65 20 L 60 10 Q 45 25 25 35 Z" fill="#34D399" />

        {/* Head */}
        <circle cx="0" cy="0" r="22" fill="#FCD34D" />

        {/* Hair */}
        <path d="M -20 -8 Q -22 -20 -13 -25 Q 0 -27 13 -25 Q 22 -20 20 -8 Z" fill="#1F2937" />

        {/* Face features - Smiling */}
        <circle cx="-8" cy="-2" r="2.5" fill="#1F2937" />
        <circle cx="8" cy="-2" r="2.5" fill="#1F2937" />
        <path d="M -10 8 Q 0 14 10 8" stroke="#1F2937" strokeWidth="2" fill="none" strokeLinecap="round" />

        {/* Neck */}
        <rect x="-7" y="20" width="14" height="12" fill="#FCD34D" />
      </g>

      {/* Welcome/Signup elements */}
      {/* User profile card */}
      <g transform="translate(120, 200)">
        <rect x="0" y="0" width="120" height="140" rx="8" fill="white" stroke="#E5E7EB" strokeWidth="2" />
        {/* Profile circle */}
        <circle cx="60" cy="40" r="25" fill="#EEF2FF" />
        <circle cx="60" cy="37" r="12" fill="#6366F1" />
        <path d="M 45 60 Q 60 52 75 60" fill="#6366F1" />
        {/* Form fields */}
        <rect x="15" y="75" width="90" height="8" rx="4" fill="#E5E7EB" />
        <rect x="15" y="90" width="90" height="8" rx="4" fill="#E5E7EB" />
        <rect x="15" y="105" width="60" height="8" rx="4" fill="#E5E7EB" />
        {/* Checkmark */}
        <circle cx="100" cy="120" r="10" fill="#10B981" />
        <path d="M 96 120 L 99 124 L 105 116" stroke="white" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      </g>

      {/* Company building icon */}
      <g transform="translate(480, 250)">
        <ellipse cx="0" cy="45" rx="25" ry="5" fill="#000" opacity="0.1" />
        <rect x="-25" y="-10" width="50" height="55" rx="4" fill="#6366F1" />
        <rect x="-22" y="-7" width="44" height="49" rx="2" fill="#818CF8" />
        {/* Windows */}
        <rect x="-18" y="0" width="8" height="8" rx="1" fill="#EEF2FF" />
        <rect x="-6" y="0" width="8" height="8" rx="1" fill="#EEF2FF" />
        <rect x="6" y="0" width="8" height="8" rx="1" fill="#EEF2FF" />
        <rect x="-18" y="12" width="8" height="8" rx="1" fill="#EEF2FF" />
        <rect x="-6" y="12" width="8" height="8" rx="1" fill="#EEF2FF" />
        <rect x="6" y="12" width="8" height="8" rx="1" fill="#EEF2FF" />
        {/* Door */}
        <rect x="-6" y="28" width="12" height="14" rx="1" fill="#4F46E5" />
      </g>

      {/* New user badge */}
      <g transform="translate(450, 420)">
        <circle cx="0" cy="0" r="35" fill="#10B981" opacity="0.2" />
        <circle cx="0" cy="0" r="25" fill="#10B981" />
        <text x="0" y="0" fill="white" fontSize="28" fontWeight="bold" textAnchor="middle" dominantBaseline="central">+</text>
      </g>

      {/* Email notification */}
      <g transform="translate(120, 380)">
        <circle cx="0" cy="20" r="12" fill="#000" opacity="0.1" />
        <rect x="-20" y="-15" width="40" height="30" rx="3" fill="#F59E0B" />
        <path d="M -20 -15 L 0 0 L 20 -15" fill="#FCD34D" stroke="#F59E0B" strokeWidth="1.5" strokeLinejoin="round" />
        {/* Notification dot */}
        <circle cx="15" cy="-10" r="6" fill="#EF4444" />
        <text x="15" y="-9" fill="white" fontSize="8" fontWeight="bold" textAnchor="middle" dominantBaseline="central">1</text>
      </g>

      {/* Security badge */}
      <g transform="translate(480, 120)">
        <ellipse cx="0" cy="30" rx="18" ry="3" fill="#000" opacity="0.1" />
        <path d="M 0 -20 L 18 -12 L 18 3 Q 18 20 0 25 Q -18 20 -18 3 L -18 -12 Z" fill="#3B82F6" />
        <path d="M 0 -16 L 13 -10 L 13 3 Q 13 16 0 20 Q -13 16 -13 3 L -13 -10 Z" fill="#60A5FA" />
        <path d="M -5 0 L -2 6 L 6 -4" stroke="white" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      </g>

      {/* Document/Form icon */}
      <g transform="translate(100, 120)">
        <circle cx="0" cy="0" r="30" fill="#EEF2FF" />
        <rect x="-12" y="-16" width="24" height="32" rx="2" fill="white" stroke="#6366F1" strokeWidth="2" />
        <rect x="-8" y="-10" width="16" height="3" rx="1.5" fill="#6366F1" />
        <rect x="-8" y="-4" width="16" height="3" rx="1.5" fill="#C7D2FE" />
        <rect x="-8" y="2" width="16" height="3" rx="1.5" fill="#C7D2FE" />
        <rect x="-8" y="8" width="10" height="3" rx="1.5" fill="#C7D2FE" />
      </g>

      {/* Team/Users icon */}
      <g transform="translate(480, 520)">
        <circle cx="0" cy="0" r="25" fill="#FEF3C7" />
        {/* Three people circles */}
        <circle cx="-10" cy="-2" r="6" fill="#F59E0B" />
        <circle cx="10" cy="-2" r="6" fill="#F59E0B" />
        <circle cx="0" cy="6" r="6" fill="#D97706" />
      </g>

      {/* Progress/Steps indicator */}
      <g transform="translate(150, 500)">
        <circle cx="0" cy="0" r="8" fill="#10B981" />
        <text x="0" y="1" fill="white" fontSize="10" fontWeight="bold" textAnchor="middle" dominantBaseline="central">1</text>

        <line x1="8" y1="0" x2="32" y2="0" stroke="#E5E7EB" strokeWidth="3" />

        <circle cx="40" cy="0" r="8" fill="#E5E7EB" />
        <text x="40" y="1" fill="#9CA3AF" fontSize="10" fontWeight="bold" textAnchor="middle" dominantBaseline="central">2</text>

        <line x1="48" y1="0" x2="72" y2="0" stroke="#E5E7EB" strokeWidth="3" />

        <circle cx="80" cy="0" r="8" fill="#E5E7EB" />
        <text x="80" y="1" fill="#9CA3AF" fontSize="10" fontWeight="bold" textAnchor="middle" dominantBaseline="central">3</text>
      </g>

      {/* Success stars */}
      <g transform="translate(420, 150)" opacity="0.6">
        <path d="M 0 -8 L 2 -2 L 8 -1 L 3 3 L 4 9 L 0 6 L -4 9 L -3 3 L -8 -1 L -2 -2 Z" fill="#F59E0B" />
      </g>
      <g transform="translate(520, 380)" opacity="0.6">
        <path d="M 0 -6 L 1.5 -1.5 L 6 -1 L 2 2 L 3 7 L 0 4.5 L -3 7 L -2 2 L -6 -1 L -1.5 -1.5 Z" fill="#10B981" />
      </g>

      {/* Floating particles with animation */}
      <circle cx="200" cy="100" r="3" fill="#6366F1" opacity="0.5">
        <animate attributeName="cy" values="100;90;100" dur="3s" repeatCount="indefinite" />
      </circle>
      <circle cx="400" cy="140" r="4" fill="#10B981" opacity="0.5">
        <animate attributeName="cy" values="140;130;140" dur="3.5s" repeatCount="indefinite" />
      </circle>
      <circle cx="530" cy="310" r="3" fill="#F59E0B" opacity="0.5">
        <animate attributeName="cy" values="310;300;310" dur="4s" repeatCount="indefinite" />
      </circle>

      {/* Bottom wave decoration */}
      <path d="M 0 570 Q 150 550 300 570 T 600 570 L 600 600 L 0 600 Z" fill="#DBEAFE" opacity="0.5" />
    </svg>
  );
};

export default RegisterIllustration;
